<template>
  <div 
    class="container-box rounded-card my-2 mx-4"
  >
    <header 
      v-if="$slots.header" 
      class="header" 
      :class="headerClasses"
    >
      <slot name="header"></slot>
    </header>
    <div 
      class="body w-full " 
      :class="[ hasheader, bodyClasses ]"   
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerClasses: {
      type: String,
      requiered: false,
      default:'text-white bg-header-bgcolor text-base text-center p-4 border-b-0 ',
    },
    bodyClasses: {
      type: String,
      requiered: false,
      default:'p-4 max-h-full items-center justify-center',
    },
  },
  computed: {
    hasheader() {
      if (this.$slots.header) {
        // console.log(this.mode + ' bordertop')

        return ' bordertop'
      }
      return ''
    },
  },
}
</script>

<style scoped>

  .thinborder {
    border: 2px solid rgb(219, 219, 219);
  }

  .shadowborder {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  }

  .bordertop {
    border-top: 0px !important;
  }
</style>
